import React, { useState } from "react";
import { Grid, Typography, Box, Select, MenuItem } from "@mui/material";
import DefaultBlock from "../components/main/DefaultBlock";
import BlueprintBlock from "../components/main/BlueprintBlock";
import BlogCard from "../components/blog/BlogPostCard";
import SEO from "../components/misc/SEO";
import blogPosts from "../blog/blog.json";

export default function Blog() {
  const [categoryFilter, setCategoryFilter] = useState("");
  const [projectFilter, setProjectFilter] = useState("");

  const categories = [...new Set(blogPosts.map((post) => post.category))];

  const filteredPosts = blogPosts
    .filter((post) => {
      return (
        (categoryFilter === "" || post.category === categoryFilter) &&
        (projectFilter === "" || post.isProject === (projectFilter === "true"))
      );
    })
    .sort((a, b) => new Date(b.posted) - new Date(a.posted));

  return (
    <div>
      <SEO
        title="Blog Articles | Aaron Hunt"
        description="Read more about my interests and projects on this page."
      />
      <BlueprintBlock text="export default function Blog() {" />
      <DefaultBlock id="blog-posts">
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Blog Articles
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              p: 2,
              alignItems: "flex-start",
              justifyContent: "start",
            }}
          >
            <Select
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
              displayEmpty
            >
              <MenuItem value="">All Categories</MenuItem>
              {categories.map((category) => (
                <MenuItem key={category} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
            <Select
              value={projectFilter}
              onChange={(e) => setProjectFilter(e.target.value)}
              displayEmpty
            >
              <MenuItem value="">All Posts</MenuItem>
              <MenuItem value="true">Projects</MenuItem>
              <MenuItem value="false">Regular Posts</MenuItem>
            </Select>
          </Box>

          {/* Center blog posts */}
          <Grid
            container
            spacing={2}
            sx={{ p: 2, maxWidth: "1400px", justifyContent: "center" }}
          >
            {filteredPosts.map((post, index) => (
              <Grid item xs={12} sm={6} md={4} key={post.id}>
                <BlogCard
                  title={post.title}
                  posted={post.posted}
                  category={post.category}
                  image={post.image}
                  id={post.id}
                  isNew={index === 0}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </DefaultBlock>
    </div>
  );
}
